<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addExamSequence()"
                    matTooltip="Einen neuen Datensatz anlegen"
                >
                    <mat-icon>add</mat-icon>
                    Neuer Datensatz
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'Name'"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Konsumenten</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Fächer</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.treeId">{{ subject.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb
                            (onStateChange)="setStatusFilter($event)"
                            [withEmptyOption]="true"
                        />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>

        <div class="table-container mat-elevation-z4">
            @if (examSequences$ | async; as examSequences) {
            <table
                mat-table
                [dataSource]="examSequences"
                [trackBy]="trackById"
            >
                <ng-container matColumnDef="id">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >ID</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        {{ examSequence.id }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Name</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        {{ examSequence.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="consumer">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Konsument</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        @if (examSequence.consumers) {
                        {{ getConsumerName(examSequence.consumers.id) }}
                        } @else {
                        ---
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="subject">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Fach</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        @if (examSequence.subjects) {
                        {{ getSubjectName(examSequence.subjects.id) }}
                        } @else {
                        ---
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="tasks">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Anzahl Aufgaben</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        {{ getAmountOfTasks(examSequence.sequence.list) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="state">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Status</th>
                    <td
                        mat-cell
                        *matCellDef="let exerciseSequence"
                    >
                        <div class="editstatus">
                            <button
                                class="badge"
                                [ngClass]="getStatusColor(exerciseSequence.approval)"
                            >
                                {{ getStatusText(exerciseSequence.approval) | transloco }}
                            </button>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Erstellungsdatum</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                    >
                        {{ getCreationDate(examSequence.id) | date }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Aktionen</th>
                    <td
                        mat-cell
                        *matCellDef="let examSequence"
                        style="width: 12%;"
                    >
                        <button
                            [class.btn-success]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="editExamSequence(examSequence)"
                            matTooltip="Datensatz bearbeiten"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button
                            [class.btn-info]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="copyExamSequence(examSequence)"
                            matTooltip="Sequenz kopieren"
                        >
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        <button
                            [class.btn-danger]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Delete"
                            matTooltip="Datensatz löschen"
                            (click)="deleteExamSequence(examSequence)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button
                            [class.btn-primary]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Delete"
                            matTooltip="Vorschau"
                            (click)="previewPlayer2(examSequence)"
                        >
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.selected-row]="currentSelectedRow() === row.id"
                ></tr>
            </table>

            } @else {
            <pixl-table-loading-spinner [name]="'Testsequenzen'" />
            }
            <mat-paginator
                [length]="totalItems || 0"
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]"
            ></mat-paginator>
        </div>
    </div>
</div>